// SPDX-License-Identifier: Apache-2.0
import { SharedFilterCondition, SharedFilter } from './sharedtypes';
import WfsFilter from '../../wfs/wfsfilter';
import WfsFilterCondition from '../../wfs/wfsfiltercondition';

// Serialize WfsFilter to SharedFilter

export const serializeWfsFilter = (wfsFilter: WfsFilter): SharedFilter => {
  return {
    conditions: wfsFilter.conditions.map((condition) => wfsFilterSerializerRecursive(condition)),
    logicalOperator: wfsFilter.logicalOperator
  } as SharedFilter;
};

const wfsFilterSerializerRecursive = (
  nestedFilter: WfsFilterCondition | WfsFilter
): SharedFilterCondition | SharedFilter => {
  return 'conditions' in nestedFilter ? serializeWfsFilter(nestedFilter) : nestedFilter;
};

// Deserialize SharedFilter to WfsFilter

export const deserializeWfsFilter = (sharedFilter: SharedFilter): WfsFilter => {
  return new WfsFilter(
    sharedFilter.conditions.map((condition) => wfsFilterDeserializerRecursive(condition)),
    sharedFilter.logicalOperator
  );
};

const deserializeWfsCondition = (sharedFilter: SharedFilterCondition): WfsFilterCondition => {
  return new WfsFilterCondition(
    sharedFilter.property,
    sharedFilter.operator,
    sharedFilter.value,
    sharedFilter.value2,
    sharedFilter.propertyType
  );
};

const wfsFilterDeserializerRecursive = (
  sharedFilter: SharedFilterCondition | SharedFilter
): WfsFilterCondition | WfsFilter => {
  return 'conditions' in sharedFilter ? deserializeWfsFilter(sharedFilter) : deserializeWfsCondition(sharedFilter);
};
